import NavLink from 'components/NavLink';
import styled from '@emotion/styled';

const PrefLink = styled(NavLink)({
  cursor: 'pointer',
  textDecoration: 'underline',
});

export default PrefLink;
